import axios from 'axios'

// discord login - must use window.location to trigger full page redirect
export const logIn = () => {
  window.location.href = 'https://api.bubblefi.xyz/auth/discord'
  // No return value since we're redirecting the page
}

// discord logout - also requires redirect
export const logOut = () => {
  window.location.href = 'https://api.bubblefi.xyz/auth/signout'
  // No return value since we're redirecting the page
}

export interface Session {
  accessToken: string
  user: {
    id: string
    username: string
    refreshToken: string
    accessToken: string

  }

}
// check if user is authenticated - this one can use axios
export const session = async (): Promise<Session | undefined> => {
  try {
    const res = await axios.get('https://api.bubblefi.xyz/auth/session', {
      withCredentials: true // Important for passing cookies/session

    })
    return res.data
  } catch (error) {
    console.error('Failed to get session:', error)
  }
}

export const userPoints = async (id: string): Promise<{ data: string, message: string } | undefined> => {
  try {
    const res = await axios.post('https://api.bubblefi.xyz/auth/user/points', {
      id
    }, {
      withCredentials: true, // Important for passing cookies/session,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return res.data
  } catch (error) {
    console.error('Failed to get session:', error)
  }
}

export interface User {
  _id: string
  user: string
  username: string
  points: number
  swapCount: number
  addLiqCount: number
}

export const ranking = async () => {
  try {
    const res = await axios.get('https://api.bubblefi.xyz/leaderboard/rank', {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    return res.data
  } catch (error) {
    console.error('Failed to get session:', error)
  }
}


/**
 * Points distributions endpoints
 */
export const releasePoints = async (
  userId: string,
  methodType: 'SWAP' | 'ADD_LIQUIDITY' | 'REMOVE_LIQUIDITY',
  transactionHash: string,
  usingBackpack: boolean,
  liqAddress?: string,
  userAddress?: string
): Promise<{
  user: string
  pointsAwarded: number
  totalPoints: number
  transactionHash: string
} | undefined > => {
  try {
    const res = await axios.post('https://api.bubblefi.xyz/points/process-action', {
      userId,
      methodType,
      transactionHash,
      usingBackpack,
      liqAddress,
      userAddress
    }, {
      withCredentials: true // Important for passing cookies/session,
    })
    return res.data
  } catch (error) {
    console.error('failed to distributed points')
  }
}

export const verifyPosition = async (userId: string): Promise<{
  positionsValid: boolean
  positions: any[]
} | undefined> => {
  try {
    const res = await axios.post('https://api.bubblefi.xyz/points/verify-positions', {
      userId
    }, {
      withCredentials: true // Important for passing cookies/session,
    })
    return res.data
  } catch (error) {
    console.error('failed to distributed points')
  }
}

export const claim = async (userId: string, poolAddress: string): Promise<{
  success: boolean
  pointsAwarded: number
  message: string
  nextClaimTime?: Date
} | undefined> => {
  try {
    const res = await axios.post('https://api.bubblefi.xyz/points/claim-rewards', {
      userId,
      poolAddress
    },{
      withCredentials: true // Important for passing cookies/session,

    })
    return res.data
  } catch (error) {
    console.error('failed to distributed points')
  }
}
